export const initialDeviceClassesState = {
    deviceClassesByProjectIdById: {},
    deviceClassIdsByProjectId: {},
};
